import Config from "../Config";
import axios from "axios";

export async function getAvatarUsers(phonenumber) {
  const apiPath = `public/avatar`;

  const request = {
    url: `https://${Config.DYNAMO_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: Config.DYNAMO_API_URL,
    path: apiPath,
    method: "POST",
    region: Config.AWS_REGION,
    service: "execute-api",
    body: JSON.stringify({ phone: phonenumber }),
    data: { phone: phonenumber },
    headers: {
      "Content-Type": "application/json",
    },
  };
  const response = await axios(request);

  return response.data;
}
